export const tips = [
  "Checkout the community page to know the story of your peers.",
];
